import type { Card } from '../types';
import { ProductImage } from './ProductImage';

type Props = {
  cards: Card[];
  onOpen: (card: Card) => void;
  busyCardId?: string | null;
};

/**
 * Витрина подборки: фото товара, бренд и название.
 *
 * Размер плитки фиксированный и не зависит от высоты экрана — на большом
 * телефоне карточки не раздуваются, на маленьком не сплющиваются. Цену не
 * показываем: её тяжело держать в актуальном виде, а неверная цена хуже, чем
 * никакой. Рамок у плитки нет — только само фото.
 */
export function ProductGrid({ cards, onOpen, busyCardId }: Props) {
  return (
    <div className="grid">
      {cards.map((card) => (
        <button
          key={card.id}
          className={`tile ${busyCardId === card.id ? 'tile--busy' : ''}`}
          onClick={() => onOpen(card)}
          disabled={busyCardId === card.id}
        >
          <div className="tile__media">
            <ProductImage
              imageUrl={card.imageUrl}
              proxyUrl={card.imageProxyUrl}
              alt={card.title}
            />
          </div>
          {card.brand && <span className="tile__brand">{card.brand}</span>}
          <span className="tile__title">{card.title}</span>
        </button>
      ))}
    </div>
  );
}
